export const translations = {
  el: {
    // Header & Navigation
    nav: {
      home: "Αρχική",
      properties: "Σπίτια",
      gallery: "Γκαλερί",
      contact: "Επικοινωνία",
      bookNow: "Κράτηση Τώρα"
    },
    
    // Home Page
    home: {
      heroTitle: "Καλώς Ήρθατε στη Σαντορίνη",
      heroSubtitle: "Ανακαλύψτε τα πολυτελή σπίτια μας με θέα σε βουνό και θάλασσα",
      viewProperties: "Δείτε τα Σπίτια μας",
      makeBooking: "Κάντε Κράτηση",
      ourHouses: "Τα Σπίτια μας",
      ourHousesSubtitle: "4 πολυτελή σπίτια με πλήρη εξοπλισμό στον Άγιο Γεώργιο, Περίβολος",
      perNight: "νύχτα",
      guests: "άτομα",
      bedrooms: "υπνοδωμάτια",
      viewAllProperties: "Δείτε Όλα τα Σπίτια",
      amenitiesTitle: "Παροχές & Υπηρεσίες",
      amenitiesSubtitle: "Όλα όσα χρειάζεστε για μια τέλεια διαμονή",
      ctaTitle: "Έτοιμοι για τις επόμενες διακοπές σας;",
      ctaSubtitle: "Κάντε κράτηση τώρα και απολαύστε την ομορφιά της Σαντορίνης",
      booking: "Κράτηση"
    },
    
    // Properties Page
    properties: {
      title: "Τα Σπίτια μας",
      subtitle: "Επιλέξτε το ιδανικό σπίτι για τη διαμονή σας",
      allHouses: "Όλα τα Σπίτια",
      twoBedroms: "2 Υπνοδωμάτια",
      threeBedroms: "3 Υπνοδωμάτια",
      upTo: "Έως",
      bathrooms: "Μπάνια",
      amenities: "Παροχές:",
      makeBooking: "Κάντε Κράτηση"
    },
    
    // Booking Page
    booking: {
      title: "Κράτηση Σπιτιού",
      bookingDetails: "Στοιχεία Κράτησης",
      checkIn: "Ημερομηνία Άφιξης",
      checkOut: "Ημερομηνία Αναχώρησης",
      selectDate: "Επιλέξτε ημερομηνία",
      guests: "Αριθμός Ατόμων",
      maximum: "Μέγιστο:",
      contactInfo: "Στοιχεία Επικοινωνίας",
      firstName: "Όνομα",
      lastName: "Επώνυμο",
      email: "Email",
      phone: "Τηλέφωνο",
      paymentInfo: "Πληροφορίες Πληρωμής (Mock)",
      cardNumber: "Αριθμός Κάρτας",
      cardExpiry: "Ημ. Λήξης",
      cardCVC: "CVC",
      completeBooking: "Ολοκλήρωση Κράτησης",
      bookingSummary: "Περίληψη Κράτησης",
      nights: "νύχτες",
      total: "Σύνολο",
      arrival: "Άφιξη:",
      departure: "Αναχώρηση:",
      required: "*"
    },
    
    // Gallery Page
    gallery: {
      title: "Γκαλερί",
      subtitle: "Ανακαλύψτε την ομορφιά της Σαντορίνης",
      experienceTitle: "Ζήστε την Εμπειρία",
      experienceText: "Η Σαντορίνη είναι ένα από τα πιο εντυπωσιακά νησιά του κόσμου. Τα σπίτια μας προσφέρουν την τέλεια θέα στην Καλντέρα και το Αιγαίο, δίνοντάς σας την ευκαιρία να ζήσετε αξέχαστες στιγμές στο νησί των ονείρων."
    },
    
    // Contact Page
    contact: {
      title: "Επικοινωνία",
      subtitle: "Είμαστε εδώ για να σας βοηθήσουμε",
      sendMessage: "Στείλτε μας μήνυμα",
      name: "Όνομα",
      email: "Email",
      phone: "Τηλέφωνο",
      message: "Μήνυμα",
      messagePlaceholder: "Πείτε μας πώς μπορούμε να σας βοηθήσουμε...",
      sendButton: "Αποστολή Μηνύματος",
      contactInfo: "Στοιχεία Επικοινωνίας",
      address: "Διεύθυνση",
      openingHours: "Ώρες Λειτουργίας",
      weekdays: "Δευτέρα - Παρασκευή: 9:00 - 20:00",
      weekends: "Σαββατοκύριακο: 10:00 - 18:00",
      needHelp: "Χρειάζεστε βοήθεια;",
      needHelpText: "Είμαστε διαθέσιμοι 24/7 για να απαντήσουμε στις ερωτήσεις σας και να σας βοηθήσουμε να βρείτε το ιδανικό σπίτι για τη διαμονή σας στη Σαντορίνη.",
      callUs: "Καλέστε μας"
    },
    
    // Footer
    footer: {
      description: "Πολυτελή ενοικιαζόμενα σπίτια στο Εμπορείο Σαντορίνης με απεριόριστη θέα.",
      quickLinks: "Γρήγοροι Σύνδεσμοι",
      newsletter: "Ενημέρωση",
      newsletterText: "Εγγραφείτε για προσφορές και νέα",
      emailPlaceholder: "Email σας",
      subscribe: "Εγγραφή",
      copyright: "Με επιφύλαξη παντός δικαιώματος."
    },
    
    // Common
    common: {
      location: "Άγιος Γεώργιος, Εμπορείο 847 03 Σαντορίνη",
      wifi: "WiFi",
      wifiDesc: "Δωρεάν υψηλής ταχύτητας",
      ac: "A/C",
      acDesc: "Σε όλους τους χώρους",
      tv: "TV",
      tvDesc: "Smart TV με streaming",
      view: "Θέα",
      viewDesc: "Απεριόριστη θέα Καλντέρας",
      parking: "Parking",
      parkingDesc: "Δωρεάν χώρος στάθμευσης"
    }
  },
  
  en: {
    // Header & Navigation
    nav: {
      home: "Home",
      properties: "Houses",
      gallery: "Gallery",
      contact: "Contact",
      bookNow: "Book Now"
    },
    
    // Home Page
    home: {
      heroTitle: "Welcome to Santorini",
      heroSubtitle: "Discover our luxury houses with mountain and sea views",
      viewProperties: "View Our Houses",
      makeBooking: "Make a Booking",
      ourHouses: "Our Houses",
      ourHousesSubtitle: "4 fully equipped luxury houses in Agios Georgios",
      perNight: "night",
      guests: "guests",
      bedrooms: "bedrooms",
      viewAllProperties: "View All Houses",
      amenitiesTitle: "Amenities & Services",
      amenitiesSubtitle: "Everything you need for a perfect stay",
      ctaTitle: "Ready for your next holidays?",
      ctaSubtitle: "Book now and enjoy the beauty of Santorini",
      booking: "Booking"
    },
    
    // Properties Page
    properties: {
      title: "Our Houses",
      subtitle: "Choose the perfect house for your stay",
      allHouses: "All Houses",
      twoBedroms: "2 Bedrooms",
      threeBedroms: "3 Bedrooms",
      upTo: "Up to",
      bathrooms: "Bathrooms",
      amenities: "Amenities:",
      makeBooking: "Make a Booking"
    },
    
    // Booking Page
    booking: {
      title: "House Booking",
      bookingDetails: "Booking Details",
      checkIn: "Check-in Date",
      checkOut: "Check-out Date",
      selectDate: "Select date",
      guests: "Number of Guests",
      maximum: "Maximum:",
      contactInfo: "Contact Information",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone",
      paymentInfo: "Payment Information (Mock)",
      cardNumber: "Card Number",
      cardExpiry: "Expiry Date",
      cardCVC: "CVC",
      completeBooking: "Complete Booking",
      bookingSummary: "Booking Summary",
      nights: "nights",
      total: "Total",
      arrival: "Arrival:",
      departure: "Departure:",
      required: "*"
    },
    
    // Gallery Page
    gallery: {
      title: "Gallery",
      subtitle: "Discover the beauty of Santorini",
      experienceTitle: "Live the Experience",
      experienceText: "Santorini is one of the most stunning islands in the world. Our houses offer the perfect view of the Caldera and the Aegean Sea, giving you the opportunity to experience unforgettable moments on the island of dreams."
    },
    
    // Contact Page
    contact: {
      title: "Contact",
      subtitle: "We are here to help you",
      sendMessage: "Send us a message",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      messagePlaceholder: "Tell us how we can help you...",
      sendButton: "Send Message",
      contactInfo: "Contact Information",
      address: "Address",
      openingHours: "Opening Hours",
      weekdays: "Monday - Friday: 9:00 AM - 8:00 PM",
      weekends: "Weekend: 10:00 AM - 6:00 PM",
      needHelp: "Need help?",
      needHelpText: "We are available 24/7 to answer your questions and help you find the perfect house for your stay in Santorini.",
      callUs: "Call us"
    },
    
    // Footer
    footer: {
      description: "Luxury vacation rentals in Emporio, Santorini with unlimited views.",
      quickLinks: "Quick Links",
      newsletter: "Newsletter",
      newsletterText: "Subscribe for offers and news",
      emailPlaceholder: "Your email",
      subscribe: "Subscribe",
      copyright: "All rights reserved."
    },
    
    // Common
    common: {
      location: "Agios Georgios, Emporio 847 03 Santorini",
      wifi: "WiFi",
      wifiDesc: "Free high-speed",
      ac: "A/C",
      acDesc: "In all areas",
      tv: "TV",
      tvDesc: "Smart TV with streaming",
      view: "View",
      viewDesc: "Unlimited Caldera view",
      parking: "Parking",
      parkingDesc: "Free parking space"
    }
  }
};
